import Vue from 'vue'


export default Vue.extend({
    data() {
        return {
            showAlert: false,
            showAlertMsg : '',
            closeEventValue : false
        }
    },
    methods : {
        //alert 창 show 상태 변경처리
        fn_open_alert :  function(msg){        
           this.showAlert = true;
           this.showAlertMsg = msg;
        },
        fn_open_alert_close :  function(msg){        
           this.showAlert = true;
           this.showAlertMsg = msg;
           this.closeEventValue = true;      
        },
        //alert 창 show 상태 변경처리
        fn_showSet :  function(value){        
            this.showAlert = value;             
        }
    }
})